import {Popover as AriaPopover} from 'react-aria-components'
import styled from 'styled-components'

export const Base = styled(AriaPopover)`
    background-color: white;
    border: 1px solid #cccccc;
    border-radius: 4px;

    padding: 8px;

    // This will make all the popover
    // in medulla to be this max height
    // by default
    max-height: 200px;
    overflow-y: auto;
`

export default Base
